<template>
	<div>
		<div class="content has-text-centered">
			<h1 class="is-title is-bold">{{$t('index.login')}}</h1>

			<div class="columns is-vcentered is-centered">
				<div class="column is-one-third-tablet is-one-quarter-desktop">
					<div class="box">
						<form v-on:submit.prevent="login">
							<label class="label">{{$t('index.email')}}</label>
							<p class="control">
								<input v-model="data.body.username" class="input" type="text" placeholder="email@example.org">
							</p>
							<label class="label">{{$t('index.password')}}</label>
							<p class="control has-text-right">
								<input v-model="data.body.password" class="input" type="password" :placeholder="$t('index.password')">
								<a @click="changePass" href="#">{{$t('index.profile.forgot_password_link')}}</a>
							</p>
							<p class="control">
								
							</p>
							<p v-html="$t('index.login_message')"></p>
							<hr>
							<p class="control has-text-centered">
								<button type="submit" class="button  is-medium is-primary ">{{$t('index.login')}}</button>
								<!-- <button class="button is-default">Cancel</button> -->
							</p>
						</form>
					</div>
				</div>
			</div>
		</div>
		<b-modal :active.sync="isForgotPassword" has-modal-card>
			<forgotpassword></forgotpassword>
		</b-modal>
	</div>
</template>

<script>
import Forgotpassword from '../mini_components/Forgotpassword.vue';
import Vue from 'vue'
import Notification from 'vue-bulma-notification'

const NotificationComponent = Vue.extend(Notification)
const openNotification = (
	propsData = {
		title: '',
		message: '',
		type: '',
		direction: '',
		duration: 4500,
		container: '.notifications'
	}
) => {
	return new NotificationComponent({
		el: document.createElement('div'),
		propsData
	})
}

export default {
	components: {
		Notification,
		Forgotpassword,
	},
	data() {
		return {
			data: {
				body: {
					username: null,
					password: null,
					byod: 1,
					devbyod:1
				},
				rememberMe: false,
				
			},
			error: null,
			isloading: false,
      	isForgotPassword: false,
		}
	},
	mounted() {
		if (this.$auth.redirect()) {
			console.log('Redirect from: ' + this.$auth.redirect().from.name)
		}
		// Can set query parameter here for auth redirect or just do it silently in login redirect.
	},
	methods: {
		openNotificationWithType(type, title, message) {
			openNotification({
				title: title,
				message: message,
				type: type
			})
		},
		login() {
			var redirect = this.$auth.redirect()
			this.$auth.login({
				headers: {
					'Content-Type': 'application/json'
				},
				data: this.data.body,
				rememberMe: this.data.rememberMe,
				redirect: { name: redirect ? redirect.from.name : 'Home' },
				success(res) {
					// axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$auth.token()
					console.log(res)
				},
				error(err) {
					if (err.response) {
						// The request was made, but the server responded with a status code
						// that falls out of the range of 2xx
						// console.log(err.response.status)
						// console.log(err.response.data)
						// console.log(err.response.headers)
						this.error = err.response.data
						// this.openNotificationWithType('danger', '', this.error.msg)
						this.openNotificationWithType('danger', '', this.$t(`index.auth_errors.${this.error.lang_msg}`))
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', err.message)
					}
					console.log(err.config)
				}
			})
		},
		changePass() {
			this.isForgotPassword = true
		}
	}

}
</script>

<style lang="scss" scoped>
.is-title {
	text-transform: capitalize;
}

</style>



// WEBPACK FOOTER //
// Login.vue?ed78a1ae